// Public entry point for the login modal. The implementation lives in
// `./login/` (split into form, OTP, and showcase carousel components). Keeping
// this re-export preserves the existing import path used by `page.tsx`.
export { default } from './login/LoginModal'
